<template>
    <v-card :loading="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)"
            flat
            tile
            key="approvalCard"
            min-width="100%"
            class="mb-2 overflow-hidden nested"
            :class="{ 'approved': approval.approved, 'declined': approval.declined }">

        <div class="pt-1 px-3 pb-5">
            <h2 class="headline font-weight-bold mb-2">
                {{ approval.first_name }} {{ approval.last_name }}
            </h2>
            <component :is="transition" mode="out-in">
                <v-container pa-0
                             v-if="approval.approved">
                    <v-icon class="mb-2 user-icon">mdi-account-check-outline</v-icon>
                    <p class="ma-0">
                        {{ $vuetify.lang.t('$vuetify.approval.participant_approved', approval.first_name, approval.last_name) }}
                    </p>
                </v-container>

                <v-container pa-0
                             v-else-if="approval.declined">
                    <v-icon class="mb-2 user-icon">mdi-account-cancel-outline</v-icon>
                    <p class="ma-0">
                        {{ $vuetify.lang.t('$vuetify.approval.participant_declined', approval.first_name, approval.last_name) }}
                    </p>
                </v-container>

                <v-container pa-0
                             v-else-if="!markedAsDeclined"
                             key="approvalCard">
                    <p class="body-1 mb-0">
                        {{ approval.profile.employment_type }}
                    </p>
                    <p class="mb-0">
                        {{ approval.profile.business_email }}
                    </p>
                    <p class="mb-4">
                        {{ approval.created_at | date }}
                    </p>

                    <v-row no-gutters align="center">
                        <v-col cols="6" class="pr-1">
                            <v-btn block
                                   tile
                                   depressed
                                   color="success"
                                   @click="transitionDirection(true); approve(approval.id, approval.profile.user)"
                                   :disabled="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)"
                                   :loading="$wait.waiting(`approve-participant-${approval.id}`)">
                                {{ $vuetify.lang.t('$vuetify.buttons.approve') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-btn block
                                   tile
                                   depressed
                                   color="error"
                                   @click="handleDeclineBtnClick"
                                   :disabled="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)"
                                   :loading="$wait.waiting(`decline-participant-${approval.id}`)">
                                {{ $vuetify.lang.t('$vuetify.buttons.decline') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container pa-0
                             v-else-if="declineReasons"
                             key="declineCard">
                    <v-icon class="mb-2 user-icon">mdi-account-cancel-outline</v-icon>
                    <p class="mb-2 pb-0 subtitle-2">
                        {{ $vuetify.lang.t('$vuetify.approval.decline_reason') }}
                    </p>
                    <v-radio-group v-model="chosenReason"
                                   class="ma-0"
                                   :mandatory="true">
                        <v-radio v-for="reason in reasons"
                                 color="white"
                                 :key="reason.id"
                                 :label="reason.reason"
                                 :disabled="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)"
                                 :value="reason.id"></v-radio>
                    </v-radio-group>

                    <v-row no-gutters align="center">
                        <v-col cols="6" class="pr-1">
                            <v-btn icon
                                   class="back-btn"
                                   @click="transitionDirection(false); markedAsDeclined = false"
                                   :disabled="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)">
                                <v-icon>mdi-arrow-left-circle-outline</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-btn block
                                   tile
                                   depressed
                                   color="error"
                                   @click="decline(approval.id, approval.profile.user, chosenReason)"
                                   :disabled="$wait.waiting(`approve-participant-${approval.id}`) || $wait.waiting(`decline-participant-${approval.id}`)"
                                   :loading="$wait.waiting(`decline-participant-${approval.id}`)">
                                {{ $vuetify.lang.t('$vuetify.buttons.decline') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

            </component>
        </div>

    </v-card>
</template>

<script>
    export default {
        name: 'approve-participant-card',
        data() {
            return {
                markedAsDeclined: false,
                chosenReason: null,
                transition: 'v-slide-left-transition',
            }
        },
        methods: {
            transitionDirection(bool) {
                this.transition = bool ? 'v-slide-left-transition' : 'v-slide-right-transition';
            },
            handleDeclineBtnClick() {
                if (this.declineReasons) {
                    this.transitionDirection(true);
                    this.markedAsDeclined = true;
                } else {
                    this.decline(this.approval.id, this.approval.profile.user)
                }
            },
        },
        props: {
            approval: {
                required: true,
                type: Object,
            },
            reasons: {
                required: true,
                type: Array,
            },
            approve: {
                required: true,
                type: Function,
            },
            decline: {
                required: true,
                type: Function,
            },
        },
        computed: {
            declineReasons() {
                return this.reasons.length > 0;
            },
        },
    }
</script>
